import React from 'react';
import { useLocation } from 'react-router-dom';
import './MobileFooter.css';
import { FaHome, FaBookmark, FaGamepad, FaBook } from 'react-icons/fa';

const MobileFooter = () => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <footer className="mobile-footer">
      <nav className="mobile-footer-nav">
        <a href="/games" className={`mobile-footer-item ${path.startsWith('/games') ? 'active' : ''}`}>
          <FaGamepad />
          <span>Games</span>
        </a>
        <a href="/animehub" className={`mobile-footer-item ${path.startsWith('/animehub') ? 'active' : ''}`}>
          <FaBookmark />
          <span>Anime</span>
        </a>
        <a href="/new-blog-home" className={`mobile-footer-item ${path.startsWith('/new-blog') ? 'active' : ''}`}>
          <FaBook />
          <span>Blog</span>
        </a>
        <a href="/manga-home" className={`mobile-footer-item ${path.startsWith('/manga') ? 'active' : ''}`}>
          <FaHome />
          <span>Manga</span>
        </a>
      </nav>
    </footer>
  );
};

export default MobileFooter;
